<template>
  <div class="renewals-feature-plans">
    <PreloaderComponent :enable="enable"></PreloaderComponent>
    <div class="content-container" v-if="enable">
      <v-card class="data-card">
        <v-card-title class="card-header">
          <v-icon left color="primary">mdi-puzzle-outline</v-icon>
          Plans fonctionnalités
          <v-spacer></v-spacer>
          <v-btn v-if="isAdministrator" color="secondary" small @click="openCreate">
            <v-icon left small>mdi-plus</v-icon>
            Nouveau plan
          </v-btn>
          <v-chip small class="ml-2">{{ plans.length }} plan(s)</v-chip>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="tableItems"
          :items-per-page="15"
          class="modern-table"
          :loading="loading"
        >
          <template v-slot:item.amount="{ item }">
            <span class="amount-value">{{ formatNumber(item.amount) }} {{ item.currency }}</span>
          </template>
          <template v-slot:item.status="{ item }">
            <v-chip x-small :color="item.status === 'ACTIVE' ? 'success' : 'grey'" class="white--text">
              {{ item.status }}
            </v-chip>
          </template>
          <template v-slot:item.entitlements="{ item }">
            <span class="mono-small">{{ entitlementsPreview(item.entitlements) }}</span>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-btn v-if="isAdministrator" icon x-small color="primary" @click="openEdit(item)" title="Éditer">
              <v-icon small>mdi-pencil</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-card>
    </div>

    <v-dialog v-model="dialog" max-width="560px" scrollable @click:outside="closeDialog">
      <v-card class="modern-card">
        <v-card-title class="dialog-title">
          <v-icon left color="primary">{{ editId ? 'mdi-pencil' : 'mdi-plus' }}</v-icon>
          {{ editId ? 'Modifier le plan fonctionnalité' : 'Nouveau plan fonctionnalité' }}
        </v-card-title>
        <v-card-text class="dialog-content pt-4">
          <v-text-field v-model="form.feature_code" label="Code fonctionnalité" outlined dense prepend-inner-icon="mdi-identifier" />
          <v-text-field v-model="form.name" label="Nom" outlined dense prepend-inner-icon="mdi-text" />
          <v-row>
            <v-col cols="6">
              <v-select
                v-model="form.type"
                :items="typeItems"
                item-text="text"
                item-value="value"
                label="Type"
                outlined
                dense
                prepend-inner-icon="mdi-calendar"
              />
            </v-col>
            <v-col cols="6">
              <v-text-field v-model.number="form.duration" label="Durée" type="number" outlined dense prepend-inner-icon="mdi-numeric" />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-text-field v-model.number="form.amount" label="Montant" type="number" outlined dense prepend-inner-icon="mdi-currency-usd" />
            </v-col>
            <v-col cols="6">
              <v-text-field v-model="form.currency" label="Devise" outlined dense prepend-inner-icon="mdi-cash" />
            </v-col>
          </v-row>
          <v-select
            v-model="form.status"
            :items="statusItems"
            label="Statut"
            outlined
            dense
            prepend-inner-icon="mdi-toggle-switch"
          />
          <v-textarea
            v-model="entitlementsJson"
            label="Entitlements (JSON)"
            outlined
            dense
            rows="4"
            hint='Objet JSON, ex. {"reports":"pro"}'
            persistent-hint
            prepend-inner-icon="mdi-code-json"
          />
        </v-card-text>
        <v-card-actions class="dialog-actions">
          <v-spacer></v-spacer>
          <v-btn text @click="closeDialog">Annuler</v-btn>
          <v-btn color="secondary" :loading="saving" @click="save">Enregistrer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import PreloaderComponent from '../../components/PreloaderComponent.vue'

export default {
  name: 'RenewalsFeaturePlansView',
  components: { PreloaderComponent },
  data() {
    return {
      enable: false,
      loading: false,
      plans: [],
      dialog: false,
      saving: false,
      editId: null,
      entitlementsJson: '{}',
      form: {
        feature_code: '',
        name: '',
        type: 'day',
        duration: 1,
        amount: 0,
        currency: 'HTG',
        status: 'ACTIVE'
      },
      typeItems: [
        { text: 'Jour(s)', value: 'day' },
        { text: 'Mois', value: 'month' }
      ],
      statusItems: ['ACTIVE', 'INACTIVE'],
      headers: [
        { text: 'CODE', value: 'feature_code' },
        { text: 'NOM', value: 'name' },
        { text: 'TYPE / DURÉE', value: 'type_duration', sortable: false, width: '120px' },
        { text: 'MONTANT', value: 'amount' },
        { text: 'ENTITLEMENTS', value: 'entitlements', sortable: false },
        { text: 'STATUT', value: 'status' },
        { text: '', value: 'actions', sortable: false, align: 'end', width: '48px' }
      ]
    }
  },
  computed: {
    isAdministrator() {
      var user = this.$store.getters.StateUser
      if (!user) return false
      var rid = user.role_id
      if (rid == null && user.role != null) {
        rid = typeof user.role === 'object' ? user.role.id : user.role
      }
      return Number(rid) === 1
    },
    tableItems() {
      var self = this
      return this.plans.map(function(p) {
        var d = p.duration != null ? p.duration : ''
        var label = d === '' ? '' : d + ' ' + self.typeLabel(p.type)
        return Object.assign({}, p, {
          type_duration: label
        })
      })
    }
  },
  mounted() {
    this.load()
  },
  methods: {
    load() {
      var self = this
      self.loading = true
      self.$axios
        .get('/subscription-feature-plans')
        .then(function(res) {
          var data = res.data
          self.plans = Array.isArray(data) ? data : []
          self.enable = true
        })
        .catch(function() {
          self.plans = []
          self.enable = true
        })
        .finally(function() {
          self.loading = false
        })
    },
    formatNumber(v) {
      if (v == null) return '0'
      return parseInt(v, 10).toLocaleString('fr-FR')
    },
    typeLabel(t) {
      if (t === 'month') return 'mois'
      if (t === 'day') return 'jour(s)'
      return t || ''
    },
    entitlementsPreview(ent) {
      if (ent == null) return '—'
      try {
        var s = JSON.stringify(ent)
        return s.length > 48 ? s.slice(0, 45) + '…' : s
      } catch (e) {
        return '—'
      }
    },
    resetForm() {
      this.editId = null
      this.form = {
        feature_code: '',
        name: '',
        type: 'day',
        duration: 1,
        amount: 0,
        currency: 'HTG',
        status: 'ACTIVE'
      }
      this.entitlementsJson = '{}'
    },
    openCreate() {
      if (!this.isAdministrator) return
      this.resetForm()
      this.dialog = true
    },
    openEdit(item) {
      if (!this.isAdministrator) return
      this.editId = item.id
      this.form = {
        feature_code: item.feature_code || '',
        name: item.name || '',
        type: item.type || 'day',
        duration: item.duration != null ? item.duration : 1,
        amount: item.amount != null ? item.amount : 0,
        currency: item.currency || 'HTG',
        status: item.status || 'ACTIVE'
      }
      this.entitlementsJson =
        item.entitlements == null ? '{}' : JSON.stringify(item.entitlements, null, 2)
      this.dialog = true
    },
    closeDialog() {
      this.dialog = false
      this.saving = false
    },
    parseEntitlements() {
      var raw = (this.entitlementsJson || '').trim()
      if (!raw) return null
      try {
        return JSON.parse(raw)
      } catch (e) {
        return { __error: true }
      }
    },
    save() {
      var self = this
      var ent = self.parseEntitlements()
      if (ent && ent.__error) {
        alert('Entitlements : JSON invalide.')
        return
      }
      var body = {
        feature_code: self.form.feature_code,
        name: self.form.name,
        type: self.form.type,
        duration: Number(self.form.duration),
        amount: Number(self.form.amount),
        currency: self.form.currency,
        status: self.form.status,
        entitlements: ent
      }
      self.saving = true
      var req = self.editId
        ? self.$axios.put('/subscription-feature-plans/' + self.editId, body)
        : self.$axios.post('/subscription-feature-plans', body)
      req
        .then(function() {
          self.closeDialog()
          self.resetForm()
          self.load()
        })
        .catch(function(err) {
          var msg = 'Erreur à la sauvegarde.'
          if (err.response && err.response.data) {
            var d = err.response.data
            msg = d.message || d.error || msg
          }
          alert(msg)
        })
        .finally(function() {
          self.saving = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.renewals-feature-plans {
  min-height: 100%;
}

.content-container {
  padding: 0 24px 24px;
}

.data-card {
  border-radius: 12px !important;
  overflow: hidden;
}

.card-header {
  padding: 16px 20px !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  font-weight: 600;
}

.amount-value {
  font-weight: 600;
  color: #003f74;
}

.mono-small {
  font-family: monospace;
  font-size: 11px;
  color: rgba(0, 0, 0, 0.65);
}

.theme--dark .mono-small {
  color: rgba(255, 255, 255, 0.65);
}
</style>
